import { findDeviceByEndpoint, updateSubscription } from "./push-service.js";
import {
  currentEndpoint,
  currentTimezone,
  isPushSupported,
} from "./subscription.js";

/**
 * Corrects this device's stored timezone when it has moved.
 *
 * Daylight saving needs no help: the stored IANA name is resolved against the
 * live zone database when the digest is scheduled, so only genuine relocation
 * has to be detected, and reading the zone at launch is enough to catch it.
 *
 * Failures are swallowed. This runs on every launch for the benefit of a feature
 * the user may not have enabled, so it must never interrupt anything.
 * @returns {Promise<void>} Resolves once the zone has been checked
 */
export async function syncPushTimezone() {
  if (!isPushSupported()) return;

  try {
    const endpoint = await currentEndpoint();
    if (!endpoint) return;

    const device = await findDeviceByEndpoint(endpoint);
    if (!device) return;

    const timezone = currentTimezone();
    if (device.timezone === timezone) return;

    await updateSubscription(device.id, {
      enabled: device.enabled,
      deviceLabel: device.deviceLabel,
      timezone,
    });
  } catch (error) {
    console.error("Failed to sync the push notification timezone", error);
  }
}
